<template>
    <div>
        <div v-if="taskType == '找图'" style="display: flex;flex-direction: column;">
            <div class="configRow">
                <div class="label">检测频率</div>
                <div class="set"><el-input-number v-model="findPic.checkRate" :min="1" :max="600"
                        label=""></el-input-number>秒</div>
            </div>
            <div class="configRow">
                <div class="label">是否全屏</div>
                <div class="set">
                    <el-radio-group v-model="findPic.isFull"    @change="handleSwitchChange">
                        <el-radio :label="0">自己选择区域</el-radio>
                        <el-radio :label="1">全屏幕范围找图</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow">
                <div class="label">目标管理</div>
                <div class="set"><el-button type="primary"
                        @click="openTargetFolder">打开目标文件夹</el-button>打开目标文件夹后把要查找的图片放进去</div>
            </div>

            <div class="configRow">
                <div class="label">相似度</div>
                <div class="set"><el-input-number v-model="findPic.similarity" :min="30" :max="100"
                        label=""></el-input-number>百分之</div>
            </div>
            <div class="configRow">
                <div class="label">提醒时机</div>
                <div class="set">
                    <el-radio-group v-model="findPic.reminderTiming">
                        <el-radio :label="0">找不到时(全部)</el-radio>
                        <el-tooltip  content="当前版本不支持此选项，请升级到5.02及以上版本" placement="top" :disabled="version>=5.02">
                            <el-radio :label="2" :disabled="version<5.02">找不到时(任意)</el-radio>
                        </el-tooltip >
                        <el-tooltip  content="当前版本不支持此选项，请升级到5.02及以上版本" placement="top" :disabled="version>=5.02">
                            <el-radio :label="3" :disabled="version<5.02">找到时(全部)</el-radio>
                        </el-tooltip >
                        <el-radio :label="1">找到时(任意)</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow">
                <div class="label">忽略条件</div>
                <div class="set">
                    <el-input v-model="findPic.ignore" placeholder="坐标=颜色 或者 坐标<>颜色 颜色值可以是RGB或者16进制，例如：200,300=255,0,0"></el-input>
                </div>
            </div>
            <div class="configRow" v-if="1==2">
                <div class="label">正则表达式</div>
                <div class="set">
                    <el-input v-model="findPic.regText"></el-input>
                </div>
            </div>
            <div class="configRow" >
                <div class="label">班次</div>
                <div class="set">
                    <el-select v-model="findPic.timeSet" placeholder="请选择" style="width: 100%;"> 
                        <el-option
                            v-for="item in workTimeSet"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </div>
            </div>
        </div>

        <div v-if="taskType == '找色'">
            <div class="configRow">
                <div class="label">检测频率</div>
                <div class="set"><el-input-number v-model="findColor.checkRate" :min="1" :max="600"
                        label=""></el-input-number>秒</div>
            </div>
            <div class="configRow">
                <div class="label">目标颜色<i class="el-icon-question" @click="help('h002')"></i></div>
                <div class="set">
                    <el-input v-model="findColor.targetColor" placeholder="请使用16进制颜色，例如：#E2E1DF，多个目标颜色用逗号分隔"></el-input>
                </div>
            </div>
            <div class="configRow">
                <div class="label">色块高</div>
                <div class="set"><el-input-number v-model="findColor.blockHeight" :min="1" :max="1000"
                        label=""></el-input-number>像素</div>
            </div>
            <div class="configRow">
                <div class="label">色块宽</div>
                <div class="set"><el-input-number v-model="findColor.blockWidth" :min="1" :max="1000"
                        label=""></el-input-number>像素</div>
            </div>
            <div class="configRow">
                <div class="label">相似度</div>
                <div class="set"><el-input-number v-model="findColor.similarity" :min="0" :max="50"
                        label=""></el-input-number>0表示绝对匹配，大于0数值越大表示允许的色差越大，最大50。</div>
            </div>
            <div class="configRow">
                <div class="label">提醒时机<i class="el-icon-question" @click="help('h001')"></i></div>
                <div class="set">
                    <el-radio-group v-model="findColor.reminderTiming">
                        <el-radio :label="0">找不到时(全部)</el-radio>
                        <el-tooltip  content="当前版本不支持此选项，请升级到5.02及以上版本" placement="top" :disabled="version>=5.02">
                            <el-radio :label="2" :disabled="version<5.02">找不到时(任意)</el-radio>
                        </el-tooltip >
                        <el-tooltip  content="当前版本不支持此选项，请升级到5.02及以上版本" placement="top" :disabled="version>=5.02">
                            <el-radio :label="3" :disabled="version<5.02">找到时(全部)</el-radio>
                        </el-tooltip >
                        <el-radio :label="1">找到时(任意)</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow">
                <div class="label">忽略条件</div>
                <div class="set">
                    <el-input v-model="findColor.ignore" placeholder="坐标=颜色 或者 坐标<>颜色 颜色值可以是RGB或者16进制，例如：200,300=255,0,0"></el-input>
                </div>
            </div>
            
            <div class="configRow" >
                <div class="label">班次</div>
                <div class="set">
                    <el-select v-model="findColor.timeSet" placeholder="请选择" style="width: 100%;"> 
                        <el-option
                            v-for="item in workTimeSet"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </div>
            </div>

        </div>
        <div v-if="taskType == '找字'">
            <div class="configRow">
                <div class="label">检测频率</div>
                <div class="set"><el-input-number v-model="findText.checkRate" :min="1" :max="600"
                        label=""></el-input-number>秒</div>
            </div>
            <div class="configRow">
                <div class="label">采样次数</div>
                <div class="set"><el-input-number v-model="findText.dataCount" :min="2" :max="600"
                        label=""></el-input-number>仅趋势判断和变化判断时有用</div>
            </div>
            <div class="configRow">
                <div class="label">{{textType=='text'?'目标文本':'脚本配置'}}</div>
                <div class="set" style="display: flex;flex-direction: row;">
                    <el-input :type="textType" :rows="rows" v-model="findText.targetText" placeholder="多个目标以英文逗号分隔，如果是介于则参考:-5_+5,20_30这样填写"></el-input>
                    <el-button @click="useJs" :type="textType=='text'?'info':'danger'">JS脚本</el-button>
                </div>
            </div>
            <div class="configRow" v-if="textType=='textarea'">
                <div class="label">JS脚本示例</div>
                <div class="set">
                    <el-input type="textarea" rows="13" placeholder="" v-model="temp"></el-input>
                    
                </div>
            </div>
            <div class="configRow">
                <div class="label">提醒时机</div>
                <div class="set">
                    <el-radio-group v-model="findText.reminderTiming" style="width: 450px;">
                        <el-radio :label="0">数值等于</el-radio>
                        <el-radio :label="1">数值不等于</el-radio>
                        <el-radio :label="2">数值介于</el-radio>
                        <el-radio :label="3">字符串包含</el-radio>
                        <el-radio :label="4">字符串不包含</el-radio>
                        <el-radio :label="5">数值上升趋势</el-radio>
                        <el-radio :label="6">数值下降趋势</el-radio>
                        <el-radio :label="7">文本变化时</el-radio>
                        <el-radio :label="8">文本不变化时</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow">
                <div class="label">忽略条件(非必填项)</div>
                <div class="set">
                    <el-input v-model="findText.ignore" placeholder="坐标=颜色 或者 坐标<>颜色 颜色值可以是RGB或者16进制，例如：200,300=255,0,0"></el-input>
                </div>
            </div>
            <div class="configRow">
                <div class="label">正则表达式(非必填项)</div>
                <div class="set">
                    <el-input v-model="findText.regText" placeholder="若填写此项则优先按正则匹配，不再以提醒时机的选项进行判断。"></el-input>
                </div>
            </div>
            <div class="configRow" v-if="1==2">
                <div class="label">识别方式</div>
                <div class="set">
                    <el-radio-group v-model="findText.ocrServer">
                        <el-radio :label="0">本地识别</el-radio>
                        <el-radio :label="1" disabled>远程识别</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow" >
                <div class="label">班次</div>
                <div class="set">
                    <el-select v-model="findText.timeSet" placeholder="请选择" style="width: 100%;"> 
                        <el-option
                            v-for="item in workTimeSet"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div v-if="taskType == '变化检测'">
            <div class="configRow">
                <div class="label">检测频率</div>
                <div class="set"><el-input-number v-model="checkChange.checkRate" :min="1" :max="600"
                        label=""></el-input-number>秒</div>
            </div>
            <div class="configRow">
                <div class="label">采样次数</div>
                <div class="set"><el-input-number v-model="checkChange.dataCount" :min="2" :max="600"
                        label=""></el-input-number>若采样N次，则“N帧图片完全相同”视为静止，“N帧图片完全不相同”视为变化。</div>
            </div>
            <div class="configRow">
                <div class="label">帧间容差</div>
                <div class="set">
                    <el-input-number v-model="checkChange.diffRate"  :min="0" :max="5000"></el-input-number>为0表示哪怕一个像素变化也算是变化，是最灵敏的，建议默认填0，如有误报再逐步调大。
                </div>
            </div>
            <div class="configRow">
                <div class="label">提醒时机</div>
                <div class="set">
                    <el-radio-group v-model="checkChange.reminderTiming" style="width: 550px;">
                        <el-radio :label="0">图像变化时</el-radio>
                        <el-radio :label="1">图像静止时</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow">
                <div class="label">忽略条件(非必填项)</div>
                <div class="set">
                    <el-input v-model="checkChange.ignore" placeholder="坐标=颜色 或者 坐标<>颜色 颜色值可以是RGB或者16进制，例如：200,300=255,0,0"></el-input>
                </div>
            </div>
            <div class="configRow" >
                <div class="label">班次</div>
                <div class="set">
                    <el-select v-model="checkChange.timeSet" placeholder="请选择" style="width: 100%;"> 
                        <el-option
                            v-for="item in workTimeSet"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </div>
            </div>

        </div>
        <div v-if="taskType == '点击任务'">
            <div class="configRow">
                <div class="label">循环间隔</div>
                <div class="set"><el-input-number v-model="clickTask.checkRate" :min="5" :max="600"
                        label=""></el-input-number>秒</div>
            </div>
            <div class="configRow">
                <div class="label">点击坐标</div>
                <div class="set">
                    <el-tooltip content="格式：(x,y,延时,按钮) 例如：(100,200,2,1)_(300,400,3,2)表示鼠标移动到(100,200),延时2秒,单击左键，再移动到(300,400),延时3秒,双击左键">
                        <el-input v-model="clickTask.targetPos" placeholder="单坐标示例：(100,100,5,1)  多坐标示例(100,100,1,5)_(100,100,3,2)"></el-input>
                    </el-tooltip>
                    
                </div>
            </div>
 
            <div class="configRow">
                <div class="label">忽略条件(非必填项)</div>
                <div class="set">
                    <el-tooltip content="满足忽略条件时不执行点击操作"> 
                        <el-input v-model="clickTask.ignore" placeholder="坐标=颜色 或者 坐标<>颜色 颜色值可以是RGB或者16进制，例如：200,300=255,0,0"></el-input>
                    </el-tooltip>
                    
                </div>
            </div>
            <div class="configRow" >
                <div class="label">班次</div>
                <div class="set">
                    <el-select v-model="clickTask.timeSet" placeholder="请选择" style="width: 100%;"> 
                        <el-option
                            v-for="item in workTimeSet"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'TaskConfig',
    props: {
        task: Object,
        curTaskIndex: Number
    },
    data() {
        return {
            version: '',
            taskType: '',
            findPic: {},
            findColor: {},
            findText: {},
            checkChange: {},
            clickTask:{},
            workTimeSet: [{label:'默认班次',value:'默认班次'},{label:'白班',value:'白班'},{label:'夜班',value:'夜班'}],
            textType:'text',
            rows:1,
            temp:`
//以下为演示脚本，请自行修改并填写到上面的脚本配置框中,函数名exec和参数arr请勿修改
function exec(arr) {
        //arr为采样到的文本数组
        let len=arr.length;
        let text=arr[len-1]; 
        if(text.indexOf('ABC')>-1){
            return {result:true,msg:'识别结果包含[ABC]'}; //返回结果必须有这两个字段
        }else{
            return {result:false,msg:'识别结果没有包含[ABC]'};
        }

           
    };
            `
            ,
            helpList:{
                h001:{title:'【找色模式】之提醒时机配置',url:'https://www.qpzt.net/newsinfo/8190089.html'},
                h002:{title:'【找色模式】之目标颜色配置',url:'https://www.qpzt.net/newsinfo/8190088.html'},
            }
        }
    },
    mounted() {

    },
    created() {
        console.log('TaskConfig created')
        console.log(this.task)
        this.version = localStorage.getItem('version')
        this.taskType = this.task.type
        console.log(this.taskType)
        if (this.taskType == '找图') {
            this.findPic = this.task.taskConfig
        }
        if (this.taskType == '找色') {
            this.findColor = this.task.taskConfig
        }
        if (this.taskType == '找字') {
            this.findText = this.task.taskConfig
        }
        if (this.taskType == '变化检测') {
            this.checkChange = this.task.taskConfig
        }
        if (this.taskType == '点击任务') {
            this.clickTask = this.task.taskConfig
        }

    },
    methods: {
        help(id){
            console.log(id)
            if(this.version<5.02){
                this.$message({
                    message: '当前版本不支持帮助链接功能，请升级到5.02及以上版本',
                    type: 'warning'
                });
                return
            }
            window.pywebview.api.openUrl(this.helpList[id].url)
        },
        openTargetFolder() {
            //获取一个时间戳
            if (!this.findPic.floder) {
                let time = new Date().getTime();
                this.findPic.floder = time
            }
            window.pywebview.api.openFile(this.findPic.floder)
        },
        handleSwitchChange(e){
            if(e==1){
                this.$emit('updateShowSquare',this.curTaskIndex)
            }
        },
        useJs(){
            let version=localStorage.getItem('version')
            if(version<5.01){
                this.$message({
                    message: '当前版本不支持JS脚本功能，请升级到最新版本5.01及以上',
                    type: 'warning'
                });
                return
            }
            if(this.textType=='text'){
                this.textType='textarea'
                this.rows=10
            }else{
                this.textType='text'
                this.rows=1
            }

        }

    },
    beforeDestroy() {

    }
}
</script>

<style scoped>
.configRow {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid whitesmoke;
    margin-bottom: 20px;
}

.label {
    width: 25%;
}

.set {
    width: 75%;
}
</style>